import { createAsyncThunk } from "@reduxjs/toolkit";
import { onboardingApi } from "../../../api";
import { RootState } from "../../../store";
import { onboardingSelectors } from "../../onboarding/onboarding.selectors";
import { ERROR_CODES } from "../constants";
import { onfidoInitialState, setOnfidoState } from "../reducer";
import { selectOnfidoState } from "../selectors";

export const getPrevOnfidoPhase = createAsyncThunk<void, void>(
  "onfido/GET_PREV_ONFIDO_PHASE",
  async (_, thunkApi) => {
    const { dispatch, rejectWithValue, getState } = thunkApi;
    const state = getState() as RootState;
    const onboardingStepData = onboardingSelectors.data(state);
    const { currentPhaseIndex } = selectOnfidoState(state);
    const processId = onboardingStepData?.processId;
    try {
      if (currentPhaseIndex > 0) {
        dispatch(
          setOnfidoState({
            currentPhaseIndex: currentPhaseIndex - 1,
          }),
        );
      } else {
        if (!processId) {
          throw Error("Process id not found");
        }
        dispatch(setOnfidoState(onfidoInitialState));
        await dispatch(onboardingApi.endpoints.back.initiate({ processId }));
      }
    } catch (err) {
      return rejectWithValue(ERROR_CODES.PREV_PHASE_GENERIC_ERROR);
    }
  },
);
